<template>
    <v-container class="py-7">

        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Incluir pedido de revisão</span>
                        <v-breadcrumbs class="app-breadcrumb" divider=">" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Incluir Pedidos de Revisão',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-on="on" id="btnGoBack" type="button" color="primary" elevation="0" outlined
                                    to="/revisao-credito">Voltar</v-btn>
                            </template>
                            <span>Voltar</span>
                        </v-tooltip>
                    </div>
                </div>

            </v-col>
        </v-row>

        <br />

        <div class="mt-4" v-if="dataset.loading">
            <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
        </div>

        <br>

        <v-row>
            <v-col cols="12" sm="8">
                <v-autocomplete v-model="selectedCreditor" :items="linkedCreditors" item-value="id" item-text="name"
                    label="Busca e seleção do credor" outlined
                    hint="Digite pelo menos 3 caracteres para iniciar a busca. A pesquisa pode ser feita pelo nome ou CPF/CNPJ do credor."
                    persistent-hint dense :search-input.sync="searchCreditor" :loading="isLoading"
                    :filter="customFilter" @update:search-input="loadCreditors" no-data-text="Nenhum credor encontrado"
                    prepend-inner-icon="mdi-magnify" return-object>
                    <template v-slot:item="data">
                        <div class="mb-2">
                            <span>{{ data.item.name }}</span><br>
                            <small class="grey--text"><strong>{{ formatRegistration(data.item.registration)
                                    }}</strong></small>
                        </div>
                    </template>
                    <template v-slot:selection="data">
                        <span>{{ data.item.name }}</span>
                    </template>
                </v-autocomplete>
            </v-col>
        </v-row>

        <v-form v-if="showMainForm" class="pt-4" ref="form" v-model="dataForm.validForm">

            <template>

                <v-row>
                    <v-col v-if="!dataset.loading">
                        <div class="d-flex align-center">
                            <h3 class="mr-5"><strong>Negócios</strong></h3>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                                    <v-btn v-bind="tooltipAttrs" v-on="tooltipOn" @click="addItem" color="green" dark
                                        x-small aria-label="Botão para adicionar um novo negócio">
                                        Adicionar <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Adicionar um novo negócio</span>
                            </v-tooltip>
                        </div>
                    </v-col>
                </v-row>
                <br>

            </template>

            <!-- <div v-for="(item, i) in dataset.data.items" :key="i"> -->
            <div v-for="(item, i) in dataset.data.items" :key="item.id || `item-${i}`">
                <v-row>
                    <v-col>
                        <strong>Negócio #{{ getItemNumber(i) }}</strong>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class='ml-5' v-bind="attrs" v-on="on" @click="removeItem(i)" dark color="#E57373"
                                    x-small aria-label="Botão para remover um negocio      ">
                                    Remover <v-icon>mdi-minus</v-icon>
                                </v-btn>
                            </template>
                            <span>Excluir negócio atual</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-expansion-panels>
                            <v-expansion-panel>
                                <v-expansion-panel-header
                                    aria-label="Formulario para ser preenchido com os dados do negócio">
                                    <div>
                                        <strong>Origem: </strong>
                                        <span>{{
                                            truncateText(item.origin || 'N/A', 30)
                                            }}</span>
                                        /
                                        <strong>Valor: </strong>
                                        <span v-if="item.amount">
                                            <!-- {{ item.amount | currency }}</span><span v-else>N/A</span> -->
                                            {{ formatValue(item.amount, item.currency) }}</span><span v-else>N/A</span>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col cols="12">
                                            <span class="mr-3"> <strong>Selecione a origem do
                                                    crédito</strong></span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small :color="'primary'" v-bind="attrs"
                                                        v-on="on">mdi-help-circle</v-icon>
                                                </template>
                                                <span>Selecione o motivo que gerou os valores do crédito</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="12">
                                            <v-autocomplete :disabled="dataset.loading" dense required
                                                :items="dataset.creditorOriginTypes"
                                                label="Selecione a origem do crédito" v-model="item.origin"
                                                item-value="name" item-text="name" :rules="[$rules.required]" outlined
                                                hide-details="auto" @change="onOriginChange(item, i)">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <span class="mr-3"> <strong>Informe a moeda e o valor referente ao
                                                    negócio</strong></span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small :color="'primary'" v-bind="attrs"
                                                        v-on="on">mdi-help-circle</v-icon>
                                                </template>
                                                <span>Informe o tipo de moeda e o valor devido</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-select :disabled="dataset.loading" required dense id="type"
                                                :items="dataset.currencyTypes" label="Selecione uma moeda"
                                                v-model="item.currency" item-value="id" item-text="name" outlined
                                                hide-details="auto" :rules="[$rules.required]">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-currency-field :disabled="dataset.loading" required label="Valor" dense
                                                aria-label="Digite o valor do negocio" v-model="item.amount"
                                                :allowNegative="false" hide-details="auto" outlined 
                                                :rules="[$rules.required]">
                                            </v-currency-field>
                                        </v-col>
                                    </v-row>


                                    <v-row>
                                        <v-col cols="12">
                                            <span class="mr-3"> <strong>Selecione a empresa devedora</strong></span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small :color="'primary'" v-bind="attrs"
                                                        v-on="on">mdi-help-circle</v-icon>
                                                </template>
                                                <span>Selecione a empresa devedora do crédito</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" sm="12">
                                            <v-autocomplete :disabled="dataset.loading" dense required
                                                :items="dataset.clients" label="Selecione a devedora"
                                                v-model="item.company_name" item-value="name" item-text="name"
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <span class="mr-3"> <strong>Informe o número de identificação do
                                                    pedido/cotação/contrato/outro</strong></span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small :color="'primary'" v-bind="attrs"
                                                        v-on="on">mdi-help-circle</v-icon>
                                                </template>
                                                <span>Informe o número de identificação do pedido</span>
                                            </v-tooltip>

                                        </v-col>

                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" class="mt-n3">
                                            <v-text-field :disabled="dataset.loading" dense
                                                label="Identificação do pedido" v-model="item.request_number"
                                                aria-label="Digite o numero de identificação do pedido" outlined
                                                hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <span class="mr-3"> <strong>Informe a sua classe no
                                                    processo</strong></span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small :color="'primary'" v-bind="attrs"
                                                        v-on="on">mdi-help-circle</v-icon>
                                                </template>
                                                <span>Selecione a classe no processo</span>
                                            </v-tooltip>
                                        </v-col>

                                        <v-col cols="12" sm="6">
                                            <span class="mr-3">
                                                <strong>
                                                    {{
                                                    item.textDateLabel === 2 ?
                                                    'Data de rescisão do contrato de trabalho' :
                                                    item.textDateLabel === 1 ?
                                                    'Data da compra / assinatura do contrato' :
                                                    'Data do evento'
                                                    }}
                                                </strong>
                                            </span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small :color="'primary'" v-bind="attrs"
                                                        v-on="on">mdi-help-circle</v-icon>
                                                </template>
                                                <span>
                                                    {{
                                                    item.textDateLabel === 2 ?
                                                    'Informe a data de rescisão do contrato de trabalho' :
                                                    item.textDateLabel === 1 ?
                                                    'Informe a data da compra / assinatura do contrato' :
                                                    'Data do evento'
                                                    }}
                                                </span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-select dense :items="dataset.creditorTypes" label="Classe"
                                                v-model="item.type" item-value="id" item-text="name" outlined
                                                hide-details="auto" :rules="[$rules.required]"
                                                @change="onClassChange(item, i)">
                                            </v-select>
                                        </v-col>

                                        <v-col cols="12" sm="6">
                                            <v-text-field dense type="date" label="Data"
                                                :value="item.ref_date ? $moment(item.ref_date).utc().format('YYYY-MM-DD') : null"
                                                outlined hide-details="auto" @input="updateRefDate($event, i)">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>


                                    <v-row v-for="(item, i) in dataset.data.items" :key="i">
                                        <v-col cols="12">
                                            <span class="mr-3"><strong>Adicione documento(s) comprobatório(s) do
                                                    negócio</strong></span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small :color="'primary'" v-bind="attrs"
                                                        v-on="on">mdi-help-circle</v-icon>
                                                </template>
                                                <span>Documentos que comprovem a origem do negócio</span>
                                            </v-tooltip>
                                        </v-col>
                                        <v-col cols="12" lg="12">
                                            <v-file-input
                                                v-model="item.files"
                                                    small-chips counter outlined dense prepend-icon=""
                                                    placeholder="Selecionar arquivos" :clearable="true" multiple
                                                    label="Documentos comprobatórios"
                                                    :show-size="1000" truncate-length="30" 
                                            >
                                                <template v-slot:selection="{ index, text }">
                                                <v-chip
                                                    v-if="index < 3"
                                                    text-color="white" color="#295671"
                                                    dark label small
                                                >
                                                    {{ text }}
                                                </v-chip>

                                                <span
                                                    v-else-if="index === 3"
                                                    class="text-overline grey--text text--darken-3 mx-2"
                                                >
                                                    +{{ item.files.length - 3 }} Arquivo(s)
                                                </span>
                                                </template>
                                            </v-file-input>
                                        </v-col>
                                    </v-row>
                                   
                                    <v-row>
                                        <v-col cols="12">
                                            <span class="mr-3"> <strong>Informe a justificativa do
                                                    pedido de revisão</strong></span>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small :color="'primary'" v-bind="attrs"
                                                        v-on="on">mdi-help-circle</v-icon>
                                                </template>
                                                <span>Justificativa para a abertura do pedido de revisão</span>
                                            </v-tooltip>
                                        </v-col>

                                        <v-col cols="12">
                                            <v-textarea :disabled="dataset.loading" dense id="description"
                                                aria-label="Preencha este campo com a justificativa para abertura do pedido de revisão"
                                                label="Justificativa do pedido" :rules="[
                                                    $rules.maxlength(
                                                        item.observation,
                                                        500
                                                    )
                                                ]" counter="500" v-model="item.observation" outlined required
                                                hide-details="auto" rows="2" auto-grow></v-textarea>
                                        </v-col>
                                    </v-row>

                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <br>
                        <br>
                    </v-col>
                </v-row>

            </div>

            <v-row>
                <v-col>
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-btn v-on="on" color="primary" :loading="dataset.loadingSave"
                                aria-label="Botão para salvar as alterações" @click.native="save">Salvar</v-btn>
                        </template>
                        <span>Salvar alterações</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-btn class="ml-4" v-on="on" type="button" elevation="0" color="primary" outlined
                                aria-label="Botão para retornar sem salvar os dados do negocio"
                                to="/revisao-credito">Voltar</v-btn>
                        </template>
                        <span>Retornar para revisão de crédito</span>
                    </v-tooltip>
                </v-col>
            </v-row>

        </v-form>

        <div v-else-if="!selectedCreditor" class="mt-4">
            <v-alert type="info">
                Por favor, selecione um credor para cadastrar uma nova revisão de crédito.
            </v-alert>
        </div>

    </v-container>
</template>

<script>
import 'moment/locale/pt-br';
import { eventHub } from '@/main';
import currencyTypes from '@/common/data/currency-types.data';
import itemTypes from "@/common/data/item-types.data.js";
import creditorTypes from "@/common/data/creditor-types.data.js";
import creditorOriginTypes from "@/common/data/creditor-origin-types.data.js";
import statesList from "@/common/data/states-list.data";
import courtList from "@/common/data/court-types.data"
import axios from 'axios';
import { debounce } from 'lodash';

export default {

    data: () => ({
        user: null,
        searchCreditor: '', //-
        valid: true,
        panel: [0],
        loadingDocuments: false,
        currentDocTypeName: '',
        linkedCreditors: [], 

        currFiles: [],
        previousFiles: [],
        files: [],
        tempFiles: [],
        selectedCreditor: null, 
        isLoading: false, 
        dataset: {
            currencyTypes: currencyTypes,
            contentUserAnonymous: '',
            contentUserLogged: '',
            clients: [],
            selectedEventItem: -1,
            textDateLabel: null,
            data: {
                //items: [],
                items: [
                        {
                            files: [],
                        },
                    ],
                actionProgress: false,
                files: [],
            },
            acceptValue: true,
            loading: false,
            loadingSave: false,
            itemTypes: itemTypes,
            creditorTypes: creditorTypes,
            creditorOriginTypes: creditorOriginTypes,
            statesList: statesList,
            courtList: courtList,
            userRequestedValue: 0,
            isAssociationCreditor: false,
            notAcceptedValue: false,
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            created: null
        },
        showDocumentModal: false,
        showAddDocumentModal: false,
        documentsCenter: [],
        newDocument: {},
        selectedPetitionDocument: null,
        selectedProcurationDocument: null,
        selectedSpreadsheet: null,
        selectSuportingDocument: [],
        selectOtherDocuments: [],
        currentDocTypeId: null,
    }),

    computed: {

        showMainForm() {
            return this.selectedCreditor;
        },
    },

    watch: {
        dataset: {
            handler(newVal) {
                newVal.data.items.forEach((item, index) => {
                    this.$watch(() => item.origin, (newValue) => {
                        this.onOriginChange(item, index);
                    });
                });
            },
            deep: true
        },

        files(val) {
            this.previousFiles = val
        }
    },

    created() {
        this.loadData();
    },

    methods: {

        resetForm() {
            this.dataset.data.items = [{
                currency: 1,
                step: 1,
                files: []
            }];
            this.dataset.data.actionProgress = false;
            this.processes = [{ number: '', local: '', court: '' }];
            this.dataset.acceptValue = true;
            this.dataset.notAcceptedValue = false;

        },

        async loadData() {
            this.loadClients();

        },

        formatValue(value, currency) {
            if (value === null || value === undefined) {
                return 'N/A';
            }

            let options = {
                style: 'currency',
                currency: 'BRL'
            };

            switch (currency) {
                case 1:
                    options.currency = 'BRL';
                    break;
                case 2:
                    options.currency = 'USD';
                    break;
                case 3:
                    options.currency = 'EUR';
                    break;
                default:
                    options.currency = 'BRL';
            }

            return new Intl.NumberFormat('pt-BR', options).format(value);
        },

        formatCpf(value) {
            if (!value) return '';
            return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
        },

        formatCnpj(value) {
            if (!value) return '';
            return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
        },

        formatRegistration(value) {
            if (!value) return '';
            return value.length <= 11 ? this.formatCpf(value) : this.formatCnpj(value);
        },

        onOriginChange(item, index) {

            if (!item) {

                return;
            }

            const selectedOrigin = this.dataset.creditorOriginTypes.find(o => o.name === item.origin);

            if (selectedOrigin) {
                if ([1, 2, 3, 4, 5].includes(selectedOrigin.id)) {

                    this.$set(this.dataset.data.items, index, {
                        ...this.dataset.data.items[index],
                        type: 3,
                        textDateLabel: 1
                    });

                }
                else {
                    this.$set(this.dataset.data.items, index, {
                        ...this.dataset.data.items[index],
                        type: 1,
                        textDateLabel: 2
                    });

                }
            }
        },

        onClassChange(item, index) {

            if (!item) {

                return;
            }

            if (item.type === 1) {

                this.$set(this.dataset.data.items, index, {
                    ...this.dataset.data.items[index],
                    textDateLabel: 2
                });

            } else if (item.type === 2 || item.type === 3 || item.type === 4) {
                this.$set(this.dataset.data.items, index, {
                    ...this.dataset.data.items[index],
                    textDateLabel: 1
                });

            }
        },

        updateRefDate(value, index) {

            this.$set(this.dataset.data.items, index, {
                ...this.dataset.data.items[index],
                ref_date: value
            });
        },


        truncateText(text, maxLength) {
            return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
        },


        loadCreditors: debounce(async function (search) {

            if (!search || search.length < 3) return;

            this.isLoading = true;

            try {
                const response = await axios.get(`/api/client/users-creditors/qgc-creditor-request-list?search=${encodeURIComponent(search)}`);

                if (Array.isArray(response.data.content)) {
                    this.linkedCreditors = response.data.content;
                } else {
                    console.log('Resposta inválida da API:', response.data.content);
                    this.linkedCreditors = [];
                }
            } catch (error) {
                console.log('Erro ao buscar credores:', error);
                this.$dialog.notify.error('Falha ao carregar credores. Tente novamente.');
            } finally {
                this.isLoading = false;
            }
        }, 300),

        customFilter(item, queryText) {
            const name = item.name.toLowerCase();
            const registration = item.registration.toLowerCase();
            const query = queryText.toLowerCase();
            return name.includes(query) || registration.includes(query);
        },

        getItemNumber(i) {
            return i + 1;
        },

        async loadClients() {
            const result = await axios.get(`/api/clients`, { params: { limit: 100000 } });

            if (!result.data.content.data) return;

            this.dataset.clients = result.data.content.data;
        },

        validateFormItems() {
            if (!this.dataset.data.items.length) return false;

            for (let item of this.dataset.data.items) {
                if (!item.origin || !item.amount || !item.currency || !item.observation) {
                    return false;
                }

                if (!item.type || (Array.isArray(item.files) && item.files.length === 0)) {
                    return false;
                }
            }
            return true;
        },

        async save() {

            if (!this.$refs.form.validate()) {

                this.$dialog.notify.error(
                    'Preencha as informações obrigatórias de um negócio antes de continuar!',
                    {
                        position: 'top-right',
                        timeout: 5000
                    }
                );
                return;
            }

            if (!this.dataset.data.items.length) {
                this.$dialog.notify.error(
                    'Preencha as informações de um negócio antes de continuar!',
                    {
                        position: 'top-right',
                        timeout: 5000
                    }
                );
                return;
            }

            if (!this.validateFormItems()) {
                this.$dialog.notify.error('Preencha todos os campos obrigatórios antes de continuar!', {
                    position: 'top-right',
                    timeout: 2000
                });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja concluir o formulário?',
                title: 'Finalizar',
                actions: {
                    false: 'Cancelar',
                    true: 'Concluir'
                }
            });

            if (!proceedAction) return;

            this.dataset.loadingSave = true;

            const payload = this.buildPayload();

            console.log("Payload: ", payload)

            try {
                const response = await axios.post('/api/admin/user-objection-events/client-event-item-create', payload, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

                this.$dialog.notify.info("Pedido de revisão de crédito enviado com sucesso!", {
                    position: "top-right",
                    timeout: 3000
                });


                this.dataset.data = { items: [] };

                this.$router.replace('/revisao-credito');
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                });
            } finally {
                this.dataset.loadingSave = false;
            }
        },

        buildPayload() {
            const formData = new FormData();

            formData.append('client_id', 1);
            formData.append('user_id', this.selectedCreditor.id);

            this.dataset.data.items.forEach((item, index) => {
                formData.append(`items[${index}][currency]`, item.currency);
                formData.append(`items[${index}][origin]`, item.origin);
                formData.append(`items[${index}][amount]`, item.amount);
                formData.append(`items[${index}][observation]`, item.observation);
                formData.append(`items[${index}][type]`, item.type);
                formData.append(`items[${index}][request_number]`, item.request_number);
                formData.append(`items[${index}][company_name]`, item.company_name);
                formData.append(`items[${index}][ref_date]`, item.ref_date);

                item.files.forEach((file) => {
                    formData.append(`items[${index}][files]`, file);
                });
            });

            return formData;
        },

        addItem() {
            this.$set(this.dataset.data.items, this.dataset.data.items.length, {
                id: Date.now(), // Chave única
                currency: 1,
                step: 1,
                files: [],
                tempFiles: [],
            });
        },

        async removeItem(index) {

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja <b>remover</b> o negócio atual?',
                title: 'Remover negócio',
                actions: {
                    false: 'Cancelar',
                    true: 'Remover'
                }
            });

            if (!proceedAction) return;

            this.dataset.data.items.splice(index, 1);
        },
    },


};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-family: 'Raleway';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    font-family: 'Raleway';
    font-size: 14px;
    font-style: normal;
}

.custom-modal-title {
    font-size: 20px;

    @media (max-width: 600px) {
        font-size: 14px;
    }
}
</style>
